import { useMemo, useRef } from 'react';
import { isEqual } from 'lodash';
import { useMounted } from './useMounted';
import { usePrevious } from './usePrevious';

/**
 * useIsDirty is a hook that, given a set of values, will
 * return `true` if any of the values have changed during the
 * lifecycle of the component.
 */
export const useIsDirty = <T>(...props: T[]): boolean => {
  const isDirtyRef = useRef(false);
  const isMounted = useMounted();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const touchedProps = useMemo(() => props, props);
  const prevTouchedProps = usePrevious(touchedProps);
  if (isMounted() && !isEqual(touchedProps, prevTouchedProps)) {
    isDirtyRef.current = true;
  }
  return isDirtyRef.current;
};
